import { Box } from '@mui/material';
import MeliIcon from 'assets/images/icons/meli-icon-thumbnail.svg';
import VtexIcon from 'assets/images/icons/vtex-icon-thumbnail.svg';
import AmazonIcon from 'assets/images/icons/amazon-icon-thumbnail.svg';

export default function ThumbnailWithIcon({ src, item }) {
	const MarketplaceIcons = {
		MELI: MeliIcon,
		VTEX: VtexIcon,
		AMZN: AmazonIcon,
	};

	const iconSrc = MarketplaceIcons[item.site || 'MELI'];

	return (
		<Box sx={{ position: 'relative', width: '30px', height: '30px' }}>
			{/* Ícono en la esquina superior izquierda */}
			<img
				src={iconSrc}
				alt={`${item.site ? `${item.site.toLowerCase()}-icon` : 'meli-icon'}`}
				style={{
					position: 'absolute',
					top: -5,
					left: -5,
					width: '13px',
					height: '13px',
					zIndex: 1,
				}}
			/>

			{/* Imagen principal */}
			<img
				src={src}
				alt="thumbnail"
				style={{
					width: '30px',
					height: '30px',
					objectFit: 'cover',
				}}
			/>
		</Box>
	);
}
